import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome-list',
	templateUrl:'./FontAwesomeListPluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesomeListPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomeListPluginCompPage
{
	mdContent_943 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5.FontAwesomeList;
\`\`\``;
	mdContent_944 = `\`\`\`java
FontAwesomeList()
\`\`\``;
	mdContent_945 = `\`\`\`java
FontAwesomeList(boolean orderedList)
\`\`\``;
	mdContent_946 = `\`\`\`java
var list = new FontAwesomeList<>();
list.addItem("Item one", new FontAwesome<>(FontAwesomeStyles.Classic, FontAwesomeIcons.check));
list.addItem("Item two", new FontAwesome<>(FontAwesomeStyles.Classic, FontAwesomeIcons.times));
list.addItem("Item three");
\`\`\``;
}
